import { useState } from "preact/compat"
import { useAsyncEffect } from "@/utils"
import {
  IntegrationWithJobInfo,
  getIntegrationsWithJobs,
  findIntegrationByName,
} from "@/api/integration"
import { LoadingSpinner } from "@/app/loading"
import { Button } from "@/components/ui/button"
import { useLocation } from "wouter-preact"
import { SettingsLayout } from "@/settings/layout"
import { IntegrationSettingsLayout, SettingsSection } from "../layout"
import { SyncStatusDisplay } from "../sync-status-row"
import wakefernLogo from "/img/integration/wakefern.png"
import { WakefernConfigForm } from "@/setup/config/wakefern/page"
import { ContractsList } from "@/contracts/contracts-list"
import { UpdateCredentialsForm } from "../update-credentials-form"

export function WakefernSettingsPage() {
  const [, setLocation] = useLocation()
  const [integration, setIntegration] = useState<IntegrationWithJobInfo | null>(null)
  const [emailAccounts, setEmailAccounts] = useState<IntegrationWithJobInfo[]>([])
  const [loading, setLoading] = useState(true)

  useAsyncEffect(async () => {
    const res = await getIntegrationsWithJobs()
    if (res.ok) {
      const integrations = res.value.data
      const emails = integrations.filter(i => ["gmail", "microsoft"].includes(i.name))
      setEmailAccounts(emails)

      const found = findIntegrationByName(integrations, "wakefern")
      if (found) {
        setIntegration(found)
      }
    }
    setLoading(false)
  }, [])

  if (loading) {
    return (
      <SettingsLayout>
        <div class="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      </SettingsLayout>
    )
  }

  if (!integration) {
    return (
      <SettingsLayout>
        <div class="text-center py-12">
          <p class="text-gray-500 mb-4">Wakefern integration not found</p>
          <Button variant="outline" onClick={() => setLocation("/settings/connections")}>
            Back to Connections
          </Button>
        </div>
      </SettingsLayout>
    )
  }

  return (
    <IntegrationSettingsLayout
      logo={wakefernLogo}
      name="Wakefern"
      username={integration.username}
      integrationId={integration.id}>
      <SettingsSection title="Sync Status">
        <SyncStatusDisplay lastSyncJob={integration.last_sync_job} />
      </SettingsSection>

      <SettingsSection title="Dispute Configuration">
        <p class="text-sm text-gray-500 mb-4">
          Configure the email account to use when sending dispute emails to Wakefern.
        </p>
        <WakefernConfigForm integration={integration} emailAccounts={emailAccounts} onSuccess={() => {}} />
      </SettingsSection>

      <SettingsSection title="Credentials">
        <UpdateCredentialsForm
          integrationName="wakefern"
          integrationId={integration.id}
          initialUsername={integration.username}
          credentialUpdatedAt={integration.credential_updated_at}
        />
      </SettingsSection>

      <SettingsSection title="Contract Documents">
        <ContractsList source="wakefern" integrationId={integration.id} />
      </SettingsSection>
    </IntegrationSettingsLayout>
  )
}
